import axiosInstance from "../../api/axiosInstance";

/* ===============================
 CREATE ORDER
================================ */
export const createPaymentOrder = (data) => {

 return axiosInstance.post(
 `/payments/create-order`,
 data
 );
};


/* ===============================
 VERIFY PAYMENT
================================ */
export const verifyPayment = (data) => {

 return axiosInstance.post(
 `/payments/verify`,
 data
 );
};


/* ===============================
 GET MY PAYMENTS
================================ */
export const fetchMyPayments = () => {

 return axiosInstance.get(
 `/payments/my-payments`
 );
};
